/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CheckDuplicateV2Payload,
  DuplicateInvoiceV2Dto,
  DuplicateInvoicesV2,
  InvoiceDuplicateUpdateRequestDto,
  InvoiceDuplicateUpdateResponseV3Dto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiInvoicesV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-invoices-v-2-controller
   * @name UpdateDuplicatesV3
   * @request POST:/api/v2/invoices/duplicates/update
   */
  updateDuplicatesV3 = (data: InvoiceDuplicateUpdateRequestDto, params: RequestParams = {}) =>
    this.http.request<InvoiceDuplicateUpdateResponseV3Dto, any>({
      path: `/v2/invoices/duplicates/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateDuplicatesV3Path = '/v2/invoices/duplicates/update'
  static updateDuplicatesV3Method = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-v-2-controller
   * @name CheckDuplicateV2
   * @request POST:/api/v2/invoices/duplicate
   */
  checkDuplicateV2 = (data: CheckDuplicateV2Payload, params: RequestParams = {}) =>
    this.http.request<DuplicateInvoiceV2Dto, any>({
      path: `/v2/invoices/duplicate`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static checkDuplicateV2Path = '/v2/invoices/duplicate'
  static checkDuplicateV2Method = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-v-2-controller
   * @name FindAllDuplicatesV2ByInvoiceId
   * @request GET:/api/v2/invoices/duplicates/{invoiceId}
   */
  findAllDuplicatesV2ByInvoiceId = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<DuplicateInvoicesV2, any>({
      path: `/v2/invoices/duplicates/${invoiceId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAllDuplicatesV2ByInvoiceIdPath = '/v2/invoices/duplicates/${invoiceId}'
  static findAllDuplicatesV2ByInvoiceIdMethod = 'GET'
}
